<template>
    <modal v-model="showModal">
        <section class="team-picker-view">
            <h3>
                <slot name="title"/>
            </h3>
            <app-alert>Type the title of the team you are looking for below</app-alert>
            <label>
                <app-input 
                    v-model="query" 
                    placeholder="Enter Title"
                    autofocus/>
            </label>
            <div v-if="query" class="teams">
                <team-table
                    :items="teams"
                    :columns="['name']"
                    :allow-sort="false"
                    :handle-click="handleSelect"
                    empty-text="No Results"/>
            </div>
        </section>
    </modal>
</template>
<script>
import TeamTable from './TeamTable'
import Team from '@/store/models/Team'

export default {
    name: 'team-picker',
    components: {
        TeamTable
    },
    props: {
        value: {
            type: Boolean,
            default: false,
            required: true
        }
    },
    data() {
        return {
            teams: [],
            query: '',
            showModal: false
        }
    },
    mounted() {
        this.showModal = this.value
    },
    methods: {
        getTeamList(query) {
            this.loading = true
            Team.$search(query).then(teams => {
                this.loading = false
                this.teams = teams
            })
        },

        handleSelect(team) {
            this.showModal = false
            this.query = ''
            this.teams = []
            this.$emit('selected-team', team)
            return false
        }
    },
    watch: {
        query(newValue) {
            this.getTeamList(newValue)
        },
        value(newValue) {
            this.showModal = newValue
        },
        showModal(newValue) {
            this.$emit('input', newValue)
        }
    }
}
</script>

<style lang="stylus">
.team-picker-view
    .alert
        margin-bottom: 15px
</style>
